'use client';
import { useEffect, useState } from 'react';

export default function NativeLinkInterceptor() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const iosBridge = (window as any)?.webkit?.messageHandlers?.app;
    if (!iosBridge) return;

    const handler = (e: MouseEvent) => {
      try {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        let el = e.target as HTMLElement | null;
        while (el && el.tagName && el.tagName.toLowerCase() !== 'a') el = el.parentElement;
        if (!el || el.tagName.toLowerCase() !== 'a') return;

        const href = (el as HTMLAnchorElement).getAttribute('href');
        if (!href || href.startsWith('#')) return;

        const abs = new URL(href, window.location.href);
        if (abs.origin !== window.location.origin) return;

        e.preventDefault();
        e.stopPropagation();
        (e as any).stopImmediatePropagation?.();

        iosBridge.postMessage({ action: 'openInNewController', url: abs.toString() });
      } catch {}
    };

    const attachListener = () => {
      window.addEventListener('click', handler, { capture: true, passive: false });
    };

    const detachListener = () => {
      window.removeEventListener('click', handler, { capture: true });
    };

    attachListener();

    const handleNativePopBack = () => {
      console.log('[NativeLinkInterceptor] Native pop detected, re-attaching...');
      detachListener();
      attachListener();
    };

    window.addEventListener('nativePopBack', handleNativePopBack);

    return () => {
      detachListener();
      window.removeEventListener('nativePopBack', handleNativePopBack);
    };
  }, []);

  return null;
}
